import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => {
  return {
    errorContainer: {
      height: '90vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    largeText: {
      fontSize: '88px',
    },
  };
});

export default useStyles;
